import { render, staticRenderFns } from "./ExcludedIp.vue?vue&type=template&id=0f94daae"
import script from "@/scripts/adminManager/systemManager/excludedIp.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/systemManager/excludedIp.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports